import {InfoCircleOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';

type StatusHelpProps = {
  message: string;
  notice?: string;
  onClose: () => void;
};

const StatusHelp: React.FC<StatusHelpProps> = ({message, notice, onClose}) => {
  return (
    <div className="flex max-h-[70vh] flex-col gap-4 px-4 pb-4">
      <div className="min-h-0 overflow-y-auto">
        <p className="text-body-xs text-gray-08">{message}</p>
        {notice && (
          <div className="mt-4 flex gap-2">
            <InfoCircleOutlined className="text-body-lg text-orange" aria-hidden />
            <p className="text-body-xs text-gray-08">
              <span className="text-orange">توجه: </span>
              {notice}
            </p>
          </div>
        )}
      </div>
      <Button variant="outline" fullWidth onClick={onClose}>
        متوجه شدم
      </Button>
    </div>
  );
};

export default StatusHelp;
